import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-striped table-sm" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "align-middle text-center small" }
const _hoisted_7 = { class: "align-middle text-center small" }
const _hoisted_8 = { class: "align-middle" }
const _hoisted_9 = { class: "text-nowrap" }
const _hoisted_10 = { class: "align-middle text-end" }
const _hoisted_11 = { class: "d-flex text-nowrap" }
const _hoisted_12 = { class: "flex-fill me-4" }
const _hoisted_13 = { class: "align-middle" }
const _hoisted_14 = { class: "d-flex justify-content-center" }
const _hoisted_15 = {
  key: 0,
  class: "p-1"
}
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkout_modal = _resolveComponent("checkout-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'd-none': _ctx.quotes?.length <= 0 })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h4", null, "Pagos Pendientes")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "fw-bold" }, [
                _createElementVNode("th", { class: "col-2 text-center" }, "Creación"),
                _createElementVNode("th", { class: "col-2 text-center" }, "Expiración"),
                _createElementVNode("th", { class: "col-6" }, "Concepto"),
                _createElementVNode("th", { class: "col-1 col-xl-1 text-center" }, "Valor"),
                _createElementVNode("th", { class: "col-1 col-xl-1 text-center" }, "Ver")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotes, (quote) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: quote.tx_id
                }, [
                  (!_ctx.isTimeToHide(quote))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formatDate((quote.createdDate as Date).getTime())), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formatDate((quote.expirationTime as Date).getTime())), 1),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(quote.concept), 1)
                        ]),
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.toTwoDecimals(Number(quote.fromAmount))), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            (quote.status == 'paid')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [...(_cache[1] || (_cache[1] = [
                                  _createElementVNode("i", { class: "fas fa-check-circle fa-fw text-success" }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-sm",
                                  onClick: ($event: any) => (_ctx.showModal(quote))
                                }, [...(_cache[2] || (_cache[2] = [
                                  _createElementVNode("i", { class: "fas fa-qrcode fa-fw" }, null, -1)
                                ]))], 8, _hoisted_16))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_checkout_modal, {
      quote: _ctx.quote,
      onClearQuote: _ctx.clearQuote,
      onRenewQuote: _ctx.createQuote
    }, null, 8, ["quote", "onClearQuote", "onRenewQuote"])
  ], 2))
}